export const panel = [
    {    
    "nombre": "Inventario",    
},
{    
    "nombre": "Ticket",    
},

]